// extracted by mini-css-extract-plugin
export default {"mainLayout":"ShoppingCart_mainLayout__v5a2c","title":"ShoppingCart_title__diMRj","emptyState":"ShoppingCart_emptyState__TxZDY","linkWrapper":"ShoppingCart_linkWrapper__e-ZpG"};